import { render, staticRenderFns } from "./Sidecart.vue?vue&type=template&id=fcf6a1dc&scoped=true&lang=pug&"
import script from "./Sidecart.vue?vue&type=script&lang=js&"
export * from "./Sidecart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf6a1dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf6a1dc')) {
      api.createRecord('fcf6a1dc', component.options)
    } else {
      api.reload('fcf6a1dc', component.options)
    }
    module.hot.accept("./Sidecart.vue?vue&type=template&id=fcf6a1dc&scoped=true&lang=pug&", function () {
      api.rerender('fcf6a1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/sidecart/Sidecart.vue"
export default component.exports